import { createFileRoute } from '@tanstack/react-router'
import ManageExtensions from 'pages/manageExtensions/ManageExtensions'

const RouteComponent = () => {
  const { orgId, siteId } = Route.useSearch()

  return <ManageExtensions orgId={orgId} siteId={siteId} />
}

export const Route = createFileRoute('/extensions/')({
  component: RouteComponent,
  staticData: {
    title: 'Extensions',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: true,
      showNavbar: true,
    },
  },
})
